import { api } from "../api";

export const signup = async (userName, email, password) => {
  return await api.post("/accounts/signup", { userName, email, password });
};

export const login = async (email, password) => {
  return await api.post("/accounts/login", { email, password });
};

export const requestPasswordReset = async (email) => {
  return await api.post("/accounts/forgot-password", { email });
};

export const resetPassword = async (token, newPassword) => {
  return await api.post("/accounts/forgot-password/reset", { token, newPassword });
};

export const validateResetToken = async (token) => {
  return await api.get(`/accounts/forgot-password/validate-token?token=${token}`);
};